import React, { useContext, useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { DocumentRequestsModel } from "../types";
import StateContext from "../context/State";
import PortalService from '../services/portal.service';



const DocumentRequestComponent = (props) => {

    const { state } = useContext(StateContext)
    const portalService = new PortalService(state);
    const [documentRequests, setDocumentRequests] = useState([{ documentName: '' }]);

    const handleChange = (e, index) => {
        const name = e.target.value;

        const newDocumentRequest = { documentName: name };
        const emptyDocumentRequest = { documentName: '' };

        if (name !== "") {
            if (documentRequests[index]) {
                documentRequests[index] = newDocumentRequest
            }
            if (documentRequests.length <= index + 1) {
                setDocumentRequests([...documentRequests, emptyDocumentRequest])
            }
        } else {
            documentRequests.splice(index, 1);
            setDocumentRequests([...documentRequests]);
        }
        
        props.setDocumentRequests([...documentRequests]);
    }

    useEffect(() => {
        if (props.addRow) {
            setDocumentRequests([...documentRequests, { documentName: '' }]);
            props.setAddRow(false);
        }
        // eslint-disable-next-line
    }, [props.addRow])

    useEffect(() => { getDocumentRequest(); }, [])
    const getDocumentRequest = async () => {
        try {
            const documentRequestResponse: DocumentRequestsModel = await portalService.getDocumentRequest(state.portalId);
            if (documentRequestResponse) {
                if (documentRequestResponse && documentRequestResponse.length !== 0 && !isObjectEmpty(documentRequestResponse)) {
                    props.setDocumentRequests([...documentRequestResponse])
                    setDocumentRequests(documentRequestResponse)
                }
            }
        } catch (e) {
            console.log('Unable to get Document Requests: ', e)
        }
    }

    return (
        <>
            <Form>
                <Table className="table-input" bordered>
                    <thead>
                        <tr>
                            <th style={{width:"40px"}}></th>
                            <th>Document Name</th>
                        </tr>
                    </thead>

                    <tbody>
                        {documentRequests.map((field, index) => {
                            return (
                                <React.Fragment key={'custom-field-' + index}>
                                    <tr>
                                        <td>
                                            <Form.Control
                                                readOnly
                                                value={index + 1}
                                            />
                                        </td>
                                        <td>
                                            <Form.Control
                                                type="text"
                                                onChange={e => handleChange(e, index)}
                                                defaultValue={field.documentName}
                                                placeholder="enter a document name.."
                                            />
                                        </td>
                                    </tr>
                                </React.Fragment>
                            )
                        })}
                    </tbody>
                </Table>
            </Form>
        </>
    )

}

const isObjectEmpty = (objectName) => {
    return JSON.stringify(objectName) === "{}";
};

export default DocumentRequestComponent;